define([
    "../hereMapsModule",
    "text!./hereMapsMarkerOverlapSelectionModal.html"
], function (hereMapsModule, hereMapsMarkerOverlapSelectionModal) {
    "use strict";

    return hereMapsModule.directive("hereMapsMarkers", [
        "hereMapsService",
        function (hereMapsService) {
            return {
                restrict: "E",
                scope: {
                    markers: "=?",
                    onRegisterApi: "=",
                    onMapRegisterApi: "=?"
                },
                controller: ["$scope", "$compile", "$timeout", function ($scope, $compile, $timeout) {
                    $scope.Here = null;
                    $scope.map = null;
                    $scope.behavior = null;
                    $scope.ui = null;
                    $scope.NEARBY_MARKERS_RADIUS_PX = 30;
                    $scope.hasTooltipInNearbyMarkersBubble = false;
                    var markerTapEvent = null;
                    var markerDragstartEvent = null;
                    var markerDragEvent = null;
                    var markerDragendEvent = null;

                    var clusterMarkerTapEvent = null;
                    var clusterMarkerDragstartEvent = null;
                    var clusterMarkerDragEvent = null;
                    var clusterMarkerDragendEvent = null;

                    var currentBubble = null;
                    var currentBubbleScope = null;


                    init();

                    function init() {
                        $scope.Here = hereMapsService.getHere();
                        $scope.map = hereMapsService.getMap();
                        $scope.behavior = hereMapsService.getBehavior();
                        $scope.ui = hereMapsService.getUi();

                        if (!$scope.Here || !$scope.map || !$scope.onRegisterApi) {
                            return;
                        }

                        $scope.dragendCallback = null;
                        $scope.dragendAction = null;
                        $scope.clusterMarkersLayer = null;
                        $scope.markersGroup = new $scope.Here.map.Group();
                        $scope.mainGroup = new $scope.Here.map.Group({
                            volatility: true,
                            objects: [$scope.markersGroup],
                        });

                        drawMarkersAndCenter($scope.markers);
                        addEventsListerner();
                        $scope.map.addObject($scope.mainGroup);
                    }

                    function drawMarkersAndCenter(markers) {
                        if (!markers || markers.length === 0) {
                            return;
                        }
                        drawMarkers(markers);

                        var boundingBox = $scope.markersGroup.getBoundingBox();
                        if (boundingBox) {
                            $scope.map.getViewPort().setPadding(50, 50, 50, 50);
                            $scope.map.getViewModel().setLookAtData({
                                bounds: boundingBox
                            });
                            if (markers.length === 1) {
                                $scope.map.setZoom(15);
                            }
                        }
                    }

                    function drawMarkers(markers) {
                        for (var i = 0; i < markers.length; i++) {
                            var currentMarker = markers[i];
                            $scope.markersGroup.addObject(currentMarker);
                        }
                    }

                    function addEventsListerner() {
                        markerTapEvent = function (event) {
                            var nearbyMarkers = getNearbyMarkers(event);
                            if (nearbyMarkers.length > 1) {
                                return openNearbyMarkersBubble(nearbyMarkers, event);
                            }
                            var target = event.target;
                            tapAction(target, event);
                        };

                        markerDragstartEvent = function (event) {
                            dragstartAction(event);
                        };

                        markerDragEvent = function (event) {
                            dragAction(event);
                        };

                        markerDragendEvent = function (event) {
                            dragendAction(event);
                        };

                        $scope.markersGroup.addEventListener("tap", markerTapEvent);
                        $scope.markersGroup.addEventListener("dragstart", markerDragstartEvent);
                        $scope.markersGroup.addEventListener("drag", markerDragEvent);
                        $scope.markersGroup.addEventListener("dragend", markerDragendEvent);
                    }

                    function tapAction(target, event) {
                        if (typeof target.getData === "function" && target.getData()) {
                            if ($scope.tapAction) {
                                $scope.$apply(function () {
                                    var tapContext = {
                                        marker: target,
                                        event: event
                                    };
                                    $scope.tapAction(tapContext);
                                });
                            }
                        }
                    }

                    function dragstartAction(event) {
                        var target = event.target;
                        var pointer = event.currentPointer;
                        var targetPosition = $scope.map.geoToScreen(target.getGeometry());

                        target["offset"] = new $scope.Here.math.Point(
                            pointer.viewportX - targetPosition.x,
                            pointer.viewportY - targetPosition.y
                        );
                        $scope.behavior.disable();
                    }

                    function dragAction(event) {
                        var pointer = event.currentPointer;
                        var target = event.target;
                        var offset = target["offset"];

                        event.target.setGeometry(
                            $scope.map.screenToGeo(
                                pointer.viewportX - offset.x,
                                pointer.viewportY - offset.y
                            )
                        );
                    }

                    function dragendAction(event) {
                        var target = event.target;
                        var dragendContext = {
                            marker: target,
                            event: event
                        };
                        if ($scope.dragendAction) {
                            $scope.dragendAction(dragendContext);
                        }
                        if ($scope.dragendCallback) {
                            $scope.dragendCallback();
                        }
                        $scope.behavior.enable();
                    }

                    function getNearbyMarkers(event) {
                        var pointer = event.currentPointer;

                        var clickX = pointer.viewportX;
                        var clickY = pointer.viewportY;

                        var radiusSquaredNearbyMarkers = $scope.NEARBY_MARKERS_RADIUS_PX
                            * $scope.NEARBY_MARKERS_RADIUS_PX;

                        return $scope.markersGroup.getObjects().filter(function (marker) {
                            if (!marker.getGeometry) {
                                return false;
                            }
                            var position = marker.getGeometry();

                            if (!position) {
                                return false;
                            }
                            var screenPoint = $scope.map.geoToScreen(position);

                            if (!screenPoint) {
                                return false;
                            }

                            var dx = screenPoint.x - clickX;
                            var dy = screenPoint.y - clickY;

                            var distance = (dx * dx + dy * dy);

                            return distance <= radiusSquaredNearbyMarkers;
                        });
                    }

                    function openNearbyMarkersBubble(nearbyMarkers, originalEvent, onMarkerSelectedCallback) {
                        closeNearbyMarkersBubble();

                        var position = originalEvent.target.getGeometry();

                        var modalOverlapMarkers = createModalOverlapMarkers({
                            titleModal: "mapsHere.overlap.markers.selection.modal.selectTargetStop",
                            markers: nearbyMarkers,
                            originalEvent: originalEvent,
                            hasTooltip: $scope.hasTooltipInNearbyMarkersBubble,
                            textTooltip: "mapsHere.overlap.markers.selection.modal.tooltip"
                        }, onMarkerSelectedCallback);

                        currentBubble = new $scope.Here.ui.InfoBubble(position, {
                            content: modalOverlapMarkers
                        });

                        $scope.ui.addBubble(currentBubble);
                    }

                    function createModalOverlapMarkers(parameter, onMarkerSelectedCallback) {
                        currentBubbleScope = $scope.$new(true);
                        currentBubbleScope.parameter = parameter;

                        currentBubbleScope.selectMarker = function (marker, originalEvent) {
                            closeNearbyMarkersBubble();

                            // garante a execução da function de forma segura
                            $timeout(function () {
                                if (onMarkerSelectedCallback) {
                                    onMarkerSelectedCallback(marker);
                                } else {
                                    tapAction(marker, originalEvent);
                                }
                            });
                        };

                        var compiledElement = $compile(hereMapsMarkerOverlapSelectionModal)(currentBubbleScope);

                        currentBubbleScope.close = function () {
                            closeNearbyMarkersBubble();
                        };

                        return compiledElement[0];
                    }

                    function closeNearbyMarkersBubble() {
                        if (currentBubble) {
                            $scope.ui.removeBubble(currentBubble);
                            currentBubble = null;
                        }

                        if (currentBubbleScope) {
                            currentBubbleScope.$destroy();
                            currentBubbleScope = null;
                        }
                    }

                    function clearMarkers() {
                        if ($scope.markersGroup) {
                            $scope.markersGroup.removeAll();
                        }
                    }

                    function clearMarker(marker) {
                        if ($scope.markersGroup) {
                            $scope.markersGroup.removeObject(marker);
                        }
                    }

                    function clearClusterMarkersLayer() {
                        if ($scope.clusterMarkersProvider) {
                            $scope.clusterMarkersProvider.removeEventListener("tap", clusterMarkerTapEvent);
                            $scope.clusterMarkersProvider = null;
                        }

                        if ($scope.clusterMarkersLayer) {
                            $scope.map.removeLayer($scope.clusterMarkersLayer);
                            $scope.clusterMarkersLayer = null;
                        }
                    }

                    // Como o markerCluster seria uma camada, temos sempre que retirar quando quisermos adicionar mais
                    function setClusterMarkers(clusterMarkersLayer, clusterMarkersProvider) {
                        if ($scope.clusterMarkersLayer) {
                            clearClusterMarkersLayer();
                        }
                        $scope.map.addLayer(clusterMarkersLayer);
                        $scope.clusterMarkersLayer = clusterMarkersLayer;
                        $scope.clusterMarkersProvider = clusterMarkersProvider;

                        addClusterEventsListener();
                    }

                    function addClusterEventsListener() {
                        clusterMarkerTapEvent = function (event) {
                            var target = event.target;
                            var clusterData = target.getData();
                            var markers = getClusterMarkers(clusterData);

                            if ($scope.tapClusterAction) {
                                $scope.$apply(function () {
                                    var tapClusterContext = {
                                        markers: markers,
                                        event: event
                                    };
                                    $scope.tapClusterAction(tapClusterContext);
                                });
                            }
                        };

                        clusterMarkerDragstartEvent = function (event) {
                            var target = event.target;
                            var clusterData = target.getData();
                            var markers = getClusterMarkers(clusterData);
                            if (markers.length > 1) {
                                return;
                            }
                            dragstartAction(event);
                        };

                        clusterMarkerDragEvent = function (event) {
                            var target = event.target;
                            var clusterData = target.getData();
                            var markers = getClusterMarkers(clusterData);
                            if (markers.length > 1) {
                                return;
                            }
                            dragAction(event);
                        };

                        clusterMarkerDragendEvent = function (event) {
                            var target = event.target;
                            var clusterData = target.getData();
                            var markers = getClusterMarkers(clusterData);
                            if (markers.length > 1) {
                                return;
                            }
                            dragendAction(event);
                        };

                        $scope.clusterMarkersProvider.addEventListener("tap", clusterMarkerTapEvent);
                        $scope.clusterMarkersProvider.addEventListener("dragstart", clusterMarkerDragstartEvent);
                        $scope.clusterMarkersProvider.addEventListener("drag", clusterMarkerDragEvent);
                        $scope.clusterMarkersProvider.addEventListener("dragend", clusterMarkerDragendEvent);

                    }

                    // retornamos sempre uma lista, quando é um um lista com um elemento,
                    // quando são vários retorna a lista deles
                    function getClusterMarkers(clusterData) {
                        // o data do cluster tem um método se é apenas um marker ou um grupo deles
                        if (clusterData.isCluster()) {
                            var markers = [];
                            clusterData.forEachDataPoint(function (dataPoint) {
                                markers.push(dataPoint);
                            });
                            return markers;
                        }
                        return [clusterData];
                    }

                    var markersApi = {};

                    markersApi.addMarkers = function (markers) {
                        drawMarkers(markers);
                    };

                    markersApi.clearMarkers = function () {
                        clearMarkers();
                    };

                    markersApi.clearMarker = function (marker) {
                        clearMarker(marker);
                    };

                    markersApi.setClusterMarkersLayer = function (clusterMarkersLayer, clusterMarkersProvider) {
                        setClusterMarkers(clusterMarkersLayer, clusterMarkersProvider);
                    };

                    markersApi.clearClusterMarkersLayer = function () {
                        clearClusterMarkersLayer();
                    };

                    markersApi.syncGeographicInfo = function (geographicInfo, id) {
                        var targetMarker = $scope.markersGroup.getObjects().find(function (marker) {
                            return marker.data.id === id;
                        });
                        if (targetMarker.getGeometry().lat === geographicInfo.latitude &&
                            targetMarker.getGeometry().lng === geographicInfo.longitude) {
                            return;
                        }

                        targetMarker.setGeometry(
                            {
                                lat: geographicInfo.latitude,
                                lng: geographicInfo.longitude
                            }
                        );
                        targetMarker.data.geographicInfo = geographicInfo;
                        $scope.map.getViewModel().setLookAtData({
                            bounds: $scope.mainGroup.getBoundingBox(),
                        });
                    };


                    // pega a area onde está todos os markers com e sem cluster
                    function getBoundingBox() {
                        var mainBounds = $scope.mainGroup ? $scope.mainGroup.getBoundingBox() : null;
                        var clusterBounds = null;

                        if ($scope.clusterMarkersProvider && $scope.clusterMarkersProvider.getRootGroup()) {
                            clusterBounds = getClusterProviderBoundingBox();
                        }

                        //trata para que não tente dar merge com null
                        if (mainBounds && clusterBounds) {
                            return mainBounds.mergeRect(clusterBounds);
                        } else if (clusterBounds) {
                            return clusterBounds;
                        } else {
                            return mainBounds;
                        }
                    }

                    function getClusterProviderBoundingBox() {
                        if (!$scope.clusterMarkersProvider.originalDataPoints ||
                            $scope.clusterMarkersProvider.originalDataPoints.length === 0) {
                            return null;
                        }

                        return new $scope.Here.geo.MultiPoint(
                            $scope.clusterMarkersProvider.originalDataPoints).getBoundingBox();
                    }

                    markersApi.centerMapOnMarkers = function () {
                        var boundingBox = getBoundingBox();
                        if (!boundingBox) {
                            return;
                        }
                        $scope.map.getViewModel().setLookAtData({
                            bounds: boundingBox,
                        });
                    };

                    markersApi.centerMapOnMarkersWithPadding = function (padding) {
                        var boundingBox = getBoundingBox();
                        if (!boundingBox) {
                            return;
                        }

                        $scope.map.getViewPort().setPadding(padding, padding, padding, padding);
                        $scope.map.getViewModel().setLookAtData({
                            bounds: boundingBox
                        });
                    };

                    markersApi.setDragendAction = function (func) {
                        $scope.dragendAction = func;
                    };

                    markersApi.setDragendCallback = function (func) {
                        $scope.dragendCallback = func;
                    };

                    markersApi.setTapAction = function (func) {
                        $scope.tapAction = func;
                    };

                    markersApi.setHasTooltipInNearbyMarkersBubble = function (hasTooltip) {
                        $scope.hasTooltipInNearbyMarkersBubble = hasTooltip;
                    };

                    markersApi.setClusterTapAction = function (func) {
                        $scope.tapClusterAction = func;
                    };

                    markersApi.focusOnMarkerByMarker = function (marker) {
                        $scope.map.setZoom(15);
                        $scope.map.setCenter(marker.getGeometry());
                    };

                    markersApi.focusOnMarkerByCoordinate = function (coordinate) {
                        if (!$scope.map || !coordinate) {
                            return;
                        }

                        $scope.map.setZoom(15);
                        $scope.map.setCenter(coordinate);

                        var screenPosition = $scope.map.geoToScreen(coordinate);
                        if (screenPosition) {
                            screenPosition.y -= 100;
                            var newCenter = $scope.map.screenToGeo(screenPosition.x, screenPosition.y);
                            $scope.map.setCenter(newCenter);
                        }
                    };

                    markersApi.getNearbyMarkers = function (event) {
                        return getNearbyMarkers(event);
                    };

                    markersApi.openNearbyMarkersBubble = function (nearbyMarkers, originalEvent, onMarkerSelectedCallback) {
                        openNearbyMarkersBubble(nearbyMarkers, originalEvent, onMarkerSelectedCallback);
                    };

                    $scope.onRegisterApi(markersApi);

                    // USADOS APENAS NO HereMapsController
                    if ($scope.onMapRegisterApi) {
                        $scope.onMapRegisterApi(markersApi);
                    }

                    $scope.$on("$destroy", function () {
                        if ($scope.map) {
                            if ($scope.markersGroup) {
                                $scope.markersGroup.removeEventListener("tap", markerTapEvent);
                                $scope.markersGroup.removeEventListener("dragstart", markerDragstartEvent);
                                $scope.markersGroup.removeEventListener("drag", markerDragEvent);
                                $scope.markersGroup.removeEventListener("dragend", markerDragendEvent);
                                $scope.markersGroup.removeAll();
                            }
                            if ($scope.mainGroup) {
                                $scope.mainGroup.removeAll();
                            }
                            clearClusterMarkersLayer();

                            $scope.Here = null;
                            $scope.map = null;
                            $scope.behavior = null;
                            $scope.mainGroup = null;
                            $scope.markersGroup = null;
                            $scope.dragendCallback = null;
                            $scope.dragendAction = null;
                        }
                    });
                }]
            };
        }]);

});